import {AuthConfig} from 'angular-oauth2-oidc';
import {environment} from '../../../environments/environment';

export const oidcAuthConfig: AuthConfig = {
  issuer: environment.AUTH.OIDC_ISSUER,
  redirectUri: window.location.origin,
  silentRefreshRedirectUri: window.location.origin + '/silent-refresh.html',
  clientId: 'price-history-frontend',
  scope: 'openid profile email',
  silentRefreshShowIFrame: false,
  showDebugInformation: false
};
